module.exports = __webpack_public_path__ + "static/img/Alessandro-Circati.2e0a1a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alessandro-Circati.jpg
// module id = Grzl
// module chunks = 0